import './finance-teaser.scss';

import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/scss';

class FinanceTeaser {
    constructor ($element) {
        this.$financeTeaser = $element;
        this.isDesktopBp = window.matchMedia('(min-width: 1024px)');
        this.$sliderContainer = this.$financeTeaser.querySelector('[data-finance-teaser="slider"]');
        this.init();
    }

    init () {
        if (this.$sliderContainer) {
            this.initSlider();
        }

        window.resizeHandler.customFunctions.push(() => {
            this.initSlider();
        });
    }

    initSlider () {
        this.slider = new Swiper(this.$sliderContainer, {
            modules: [Navigation, Pagination],
            slidesPerView: 'auto',
            speed: 500,
            autoHeight: false,
            navigation: {
                el: this.$financeTeaser.querySelector('.finance-teaser__slider-navigation'),
                nextEl: this.$financeTeaser.querySelector('.slider-button-next'),
                prevEl: this.$financeTeaser.querySelector('.slider-button-prev')
            },
            pagination: {
                el: this.$financeTeaser.querySelector('.slider-pagination'),
                type: 'fraction',
                formatFractionCurrent: function (number) {
                    return ('0' + number).slice(-2);
                },
                formatFractionTotal: function (number) {
                    return ('0' + number).slice(-2);
                }
            },
            on: {
                afterInit: () => {
                    if (this.$financeTeaser.querySelector('.slider-button-next').classList.contains('swiper-button-disabled') & this.$financeTeaser.querySelector('.slider-button-prev').classList.contains('swiper-button-disabled')) {
                        this.$financeTeaser.querySelector('.finance-teaser__slider-navigation').style.display = 'none';
                    } else {
                        this.$financeTeaser.querySelector('.finance-teaser__slider-navigation').style.display = 'flex';
                    }
                }
            }
        });
    }
}

export { FinanceTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $financeTeasers = $context.querySelectorAll('[data-finance-teaser="root"]');

        for (let i = 0; i < $financeTeasers.length; i++) {
            const $financeTeaser = new FinanceTeaser($financeTeasers[i]);
            $financeTeaser.init();
        }
    }
});
